module.exports = __webpack_public_path__ + "static/img/7695_phase_function_Paper_PointsHejduk_Prediction.016d0a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7695_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +syU
// module chunks = 0